import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tmwfileSize',
  standalone: true,
})
export class TmwFileSizePipe implements PipeTransform {
  transform(bytes: number | string | null | undefined): string {
    if (bytes === null || bytes === undefined || bytes === '') {
      return '-';
    }

    const numBytes = typeof bytes === 'string' ? parseFloat(bytes) : bytes;

    if (isNaN(numBytes) || numBytes === 0) {
      return '0 B';
    }

    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const k = 1024;
    const i = Math.floor(Math.log(numBytes) / Math.log(k));

    const size = numBytes / Math.pow(k, i);
    const formattedSize = i === 0 ? size.toString() : size.toFixed(2);

    return `${formattedSize} ${units[i]}`;
  }
}
